<template>
  <div class="contactform__wrapper">
    <slot></slot>
    <transition name="formData">
      <form class="contactform contactform--padding-top">
        <div class="contactform__text">
          <h3>{{ formTitle }}</h3>
          <div class="contactform__text-helper">
            <p>{{ textHelp }}</p>
          </div>
        </div>
        <div class="contactform__input">
          <Inputfield
            phName="Asunto"
            name="subject"
            type="text"
            v-model="userContact.subject"
            typemsg="error"
          >
            <span v-if="$v.userContact.username.$error">{{
              requiredText
            }}</span>
          </Inputfield>
          <Inputfield
            phName="Nombre Completo"
            name="username"
            type="text"
            v-model="$v.userContact.username.$model"
            :showError="$v.userContact.username.$error"
            typemsg="error"
          >
            <span v-if="$v.userContact.username.$error">{{
              requiredText
            }}</span>
          </Inputfield>

          <Inputfield
            phName="Email"
            name="email"
            type="text"
            v-model="$v.userContact.email.$model"
            :showError="$v.userContact.email.$error"
            typemsg="error"
          >
            <span v-if="$v.userContact.email.$error">{{ requiredEmail }}</span>
          </Inputfield>

          <Inputfield
            phName="Teléfono"
            name="phone"
            type="text"
            v-model="$v.userContact.phone.$model"
            :showError="$v.userContact.phone.$error"
            typemsg="error"
          >
            <span v-if="$v.userContact.phone.$error">{{ phoneLenght }}</span>
          </Inputfield>

          <TextField
            phName="Mensaje"
            name="message"
            v-model="userContact.message"
            typemsg="error"
            :showError="false"
            :errorMessage="false"
            :rows="4"
            :cols="40"
          >
          </TextField>

          <div class="contactform__button" @click="updateContact(userContact)">
            {{ buttonText }}
          </div>
        </div>
      </form>
    </transition>
  </div>
</template>
<script>
import { required, email, numeric, minLength } from "vuelidate/lib/validators";
import Inputfield from "@/components/atoms/InputField";
import TextField from "@/components/atoms/TextArea";
import { VueRecaptcha } from "vue-recaptcha-v3";
export default {
  name: "contactForm",
  props: [
    "isShown",
    "buttonText",
    "formTitle",
    "textHelp",
    "showPhone",
    "item",
  ],

  components: {
    Inputfield,
    TextField,
    VueRecaptcha,
  },

  data() {
    return {
      userContact: {
        username: "",
        phone: "",
        email: "",
        subject: "",
        message: "",
        landingPage: "",
      },
      requiredText: "Este campo es obligatorio",
      requiredEmail: "Introduce una direccion valida ",
      phoneLenght: "El teléfono debe tener al menos 10 dígitos",
    };
  },

  validations: {
    userContact: {
      username: { required },
      email: { required, email },
      phone: { minLength: minLength(10), numeric },
    },
  },

  methods: {
    async updateContact(userContact) {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        await this.$recaptchaLoaded();
        const gToken = await this.$recaptcha();
        const CONTACT = {
          subject: userContact.subject,
          userName: userContact.username,
          email: userContact.email,
          phone: userContact.phone,
          message: userContact.message,
          landingPage: "Montebit",
          captcha: gToken,
        };
        this.$store.dispatch("sendContactEmail", CONTACT).then(() => {
          this.userContact = {
            username: "",
            phone: "",
            email: "",
            subject: "",
            message: "",
            landingPage: "",
          },
          this.$v.$reset();
        });
      }
    },
  },
};
</script>